import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row row-material-symbol mb-4"
}
const _hoisted_2 = { class: "h5" }
const _hoisted_3 = {
  key: 1,
  class: "row row-material-symbol mb-2"
}
const _hoisted_4 = {
  class: "col-auto ms-2 alert alert-secondary",
  role: "alert"
}
const _hoisted_5 = {
  href: "https://fonts.google.com/icons",
  target: "_blank",
  class: "mb-5"
}
const _hoisted_6 = {
  key: 2,
  class: "row row-material-symbol mb-4"
}
const _hoisted_7 = { class: "col-auto col-material-symbol-preview" }
const _hoisted_8 = { class: "row row-material-symbol mb-4" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = ["data-dp-tooltip"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 fs-5" }, "help", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "col-auto" }
const _hoisted_15 = { class: "row row-properties mb-4" }
const _hoisted_16 = { class: "col-auto" }
const _hoisted_17 = { class: "col-auto" }
const _hoisted_18 = { class: "col-auto" }
const _hoisted_19 = { class: "col-auto" }
const _hoisted_20 = { class: "col-12 mt-3" }
const _hoisted_21 = { class: "row row-colors mb-4" }
const _hoisted_22 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreviewMaterialSymbol = _resolveComponent("PreviewMaterialSymbol")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_Subtitle = _resolveComponent("Subtitle")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputCheckboxBoolean = _resolveComponent("InputCheckboxBoolean")!
  const _component_ColorPicker = _resolveComponent("ColorPicker")!
  const _component_GenericComponentWrapper = _resolveComponent("GenericComponentWrapper")!

  return (_openBlock(), _createBlock(_component_GenericComponentWrapper, { componentUI: _ctx.componentUI }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (_ctx.title !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showExternalInfo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createTextVNode(_toDisplayString(_ctx.$t('cms.helpTextSymbol1')) + " ", 1),
                _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$t('cms.helpTextSymbol2')), 1),
                _createTextVNode(". ")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showPreview)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_PreviewMaterialSymbol, { "material-symbol": _ctx.localDto }, null, 8, ["material-symbol"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_InputText, {
                modelValue: _ctx.localDto.name_code,
                label: _ctx.$t('symbol'),
                name: _ctx.name + '_name_code',
                rules: "required|max:100",
                errors: _ctx.errors,
                "onUpdate:modelValue": _ctx.onChangeSymbolName
              }, null, 8, ["modelValue", "label", "name", "errors", "onUpdate:modelValue"]),
              _createElementVNode("span", {
                "data-dp-tooltip": _ctx.$t('cms.helpTextSymbolName'),
                "data-dp-position": "top",
                class: "d-flex cu-p ms-2 mb-3"
              }, _hoisted_13, 8, _hoisted_11)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_InputSelect, {
              modelValue: _ctx.localDto.family_code,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localDto.family_code) = $event)),
                _ctx.emitModelChanged
              ],
              label: _ctx.$t('family'),
              name: _ctx.name + '_family',
              selectText: _ctx.$t('selectText'),
              options: _ctx.symbolFamilyOptions,
              rules: "required",
              errors: _ctx.errors
            }, null, 8, ["modelValue", "label", "name", "selectText", "options", "errors", "onUpdate:modelValue"])
          ])
        ]),
        _createVNode(_component_Subtitle, {
          title: _ctx.$t('properties')
        }, null, 8, ["title"]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_InputNumber, {
              modelValue: _ctx.localDto.size_in_rem,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localDto.size_in_rem) = $event)),
              label: _ctx.$t('size'),
              name: _ctx.name + '_size',
              min: 0,
              step: .01,
              rules: "required",
              errors: _ctx.errors,
              mode: "group-end",
              "addon-text": "rem"
            }, null, 8, ["modelValue", "label", "name", "errors"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_InputSelect, {
              modelValue: _ctx.localDto.weight_code,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localDto.weight_code) = $event)),
                _ctx.emitModelChanged
              ],
              label: _ctx.$t('cms.weight'),
              name: _ctx.name + '_weight',
              selectText: _ctx.$t('selectText'),
              options: _ctx.symbolWeightOptions,
              rules: "required",
              errors: _ctx.errors
            }, null, 8, ["modelValue", "label", "name", "selectText", "options", "errors", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_InputSelect, {
              modelValue: _ctx.localDto.grade_code,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localDto.grade_code) = $event)),
                _ctx.emitModelChanged
              ],
              label: _ctx.$t('cms.grade'),
              name: _ctx.name + '_grade_code',
              selectText: _ctx.$t('selectText'),
              options: _ctx.symbolGradeOptions,
              rules: "required",
              errors: _ctx.errors
            }, null, 8, ["modelValue", "label", "name", "selectText", "options", "errors", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_InputSelect, {
              modelValue: _ctx.localDto.optical_size_code,
              "onUpdate:modelValue": [
                _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localDto.optical_size_code) = $event)),
                _ctx.emitModelChanged
              ],
              label: _ctx.$t('cms.opticalSize'),
              name: _ctx.name + '_opticalSize',
              selectText: _ctx.$t('selectText'),
              options: _ctx.symbolOpticalSizeOptions,
              rules: "required",
              errors: _ctx.errors
            }, null, 8, ["modelValue", "label", "name", "selectText", "options", "errors", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_InputCheckboxBoolean, {
              modelValue: _ctx.localDto.is_filled,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localDto.is_filled) = $event)),
              label: _ctx.$t('cms.filled'),
              name: _ctx.name + '_isFilled',
              errors: _ctx.errors
            }, null, 8, ["modelValue", "label", "name", "errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_ColorPicker, {
              modelValue: _ctx.localDto.default_state_color,
              "onUpdate:modelValue": [
                _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localDto.default_state_color) = $event)),
                _ctx.emitModelChanged
              ],
              label: _ctx.$t('color'),
              name: _ctx.name + '_default_state_color'
            }, null, 8, ["modelValue", "label", "name", "onUpdate:modelValue"]),
            _createVNode(_component_ColorPicker, {
              modelValue: _ctx.localDto.hover_state_color,
              "onUpdate:modelValue": [
                _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localDto.hover_state_color) = $event)),
                _ctx.emitModelChanged
              ],
              label: `${_ctx.$t('color')} ${_ctx.$t('cms.hover').toLowerCase()}`,
              name: _ctx.name + '_hover_state_color'
            }, null, 8, ["modelValue", "label", "name", "onUpdate:modelValue"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["componentUI"]))
}